import React, { useEffect } from 'react';
import classNames from 'classnames';
import { NamedLink } from '..';
import css from './NotificationToast.module.css';

/**
 * Brief popup toast for notifications.
 * Props:
 * - open: boolean
 * - message: string | ReactNode
 * - onClose: () => void
 * - timeoutMs?: number (default 5000)
 */
const NotificationToast = ({ open, message, onClose, timeoutMs = 5000, targetTab }) => {
  useEffect(() => {
    if (!open) return;
    const id = setTimeout(() => onClose?.(), timeoutMs);
    return () => clearTimeout(id);
  }, [open, timeoutMs, onClose]);

  return (
    <div className={classNames(css.root, { [css.open]: open })} role="status" aria-live="polite">
      <span className={css.icon} aria-hidden>
        🔔
      </span>
      <div className={css.message}>{message}</div>
      <div className={css.actions}>
        <NamedLink
          className={css.button}
          name="InboxPage"
          params={{ tab: targetTab === 'sales' ? 'sales' : 'orders' }}
        >
          View
        </NamedLink>
        <button className={classNames(css.button, css.close)} onClick={onClose} aria-label="Dismiss">
          Close
        </button>
      </div>
    </div>
  );
};

export default NotificationToast;
